export default __webpack_public_path__ + "static/media/Carousel1.041f5b73.jpg";